<template>
  <el-dialog :visible.sync="selfVisible" width="400px" @close="handleClose">
    <div>小程序路径：{{ path }}</div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="selfVisible = false">取消</el-button>
      <el-button
        type="primary"
        v-clipboard:copy="path"
        v-clipboard:success="onCopy"
      >复制</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'PathDialog',
  data() {
    return {
      selfVisible: false,
      path: '',
    };
  },
  props: {
    configPath: {
      type: String,
      default: '',
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    visible: {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.selfVisible = newValue;
        }
      },
      immediate: true,
    },
    configPath: {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.path = newValue;
        }
      },
      immediate: true,
    },
  },
  methods: {
    // 复制
    onCopy(e) {
      if (e.text) {
        this.$message.success('已复制');
        this.dialogVisible = false;
      }
    },
    handleClose() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="stylus" scoped>
>>>.el-dialog__header
  padding 13px 20px
  .el-dialog__headerbtn
    top 16px
</style>
